import {
  UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN,
  UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS,
  UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

const PATCHED_TWEET_KEY = "patchedTweet";

export function updateTweetsIsSarcasmManuallyToggled(props = {}) {
  return dispatch => {
    dispatch({
      type: UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN,
    });
    const url = `${apiEndPoints.tweets.UPDATE_TWEET_IS_SARCASM_MANUALLY_TOGGLED}?tweetId=${props.commentId}&isSarcasmManuallyToggled=${props.isSarcasmManuallyToggled}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.patch(url);
      doRequest.then(
        res => {
          dispatch({
            type: UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN:
      return {
        ...state,
        updateTweetsIsSarcasmManuallyToggledBegin: true,
        updateTweetsIsSarcasmManuallyToggledSuccess: false,
        updateTweetsIsSarcasmManuallyToggledFailure: false,
        updateCrawledCommentsIsSarcasmManuallyToggledSuccess: false,
        updateCrawledCommentsIsSarcasmManuallyToggledFailure: false,
        updateUploadedCommentsIsSarcasmManuallyToggledSuccess: false,
        updateUploadedCommentsIsSarcasmManuallyToggledFailure: false,
        commentOrTweetAfterToggling: null
      };
    case UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS:
      const updatedTweets = state.allTweets.data.map(tweet => {
        if (String(tweet.tweetId) === String(action.data.data[PATCHED_TWEET_KEY]["tweetId"])) {
          tweet =  action.data.data[PATCHED_TWEET_KEY];
        }
        return tweet;
      });
      state.allTweets.data = updatedTweets;
      return {
        ...state,
        updateTweetsIsSarcasmManuallyToggledBegin: false,
        updateTweetsIsSarcasmManuallyToggledSuccess: true,
        commentOrTweetAfterToggling: action.data.data[PATCHED_TWEET_KEY]
      };
    case UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE:
      return {
        ...state,
        updateTweetsIsSarcasmManuallyToggledBegin: false,
        updateTweetsIsSarcasmManuallyToggledFailure: true,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/home/redux/updateTweetsIsSarcasmManuallyToggled.js